import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=117f5fe7&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=117f5fe7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f5fe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117f5fe7')) {
      api.createRecord('117f5fe7', component.options)
    } else {
      api.reload('117f5fe7', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=117f5fe7&scoped=true", function () {
      api.rerender('117f5fe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Sidebar.vue"
export default component.exports